module.exports = __webpack_public_path__ + "static/media/james-michael-baker.9c75dd09.md";